import { Panzoom } from "@fancyapps/ui/dist/panzoom/panzoom.esm.js";
import { Carousel, Fancybox } from '@fancyapps/ui/';
import { Thumbs } from '@fancyapps/ui/dist/carousel/carousel.thumbs.esm.js';

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return void
 */
export function initializeBlock(block: HTMLElement) {
  jQuery(".variations_form").on(
    "woocommerce_variation_select_change",
    function () {
      const figures: NodeListOf<HTMLElement> = block.querySelectorAll(
        ".wp-block-site-product-gallery__gallery",
      );

      for (var i = 0; i < figures.length; i++) {
        figures[i].style.display = "none";
      }

			const figure: HTMLElement | null = block.querySelector(
        `.wp-block-site-product-gallery__gallery:first-child`,
      );

      if (figure) {
        figure.style.display = "block";
      }
    },
  );

  jQuery(".single_variation_wrap").on(
    "show_variation",
    function (event, variation) {
      const variation_id = variation.variation_id;

			const figures: NodeListOf<HTMLElement> = block.querySelectorAll(
        `.wp-block-site-product-gallery__gallery:not(.product-${variation_id})`,
      );

			for (var i = 0; i < figures.length; i++) {
        figures[i].style.display = "none";
      }

      const figure: HTMLElement | null = block.querySelector(
        `.wp-block-site-product-gallery__gallery.product-${variation_id}`,
      );

      if (figure) {
        figure.style.display = "block";
      }
    },
  );

  block.querySelectorAll<HTMLElement>('.productCarousel')
    .forEach((el: HTMLElement) => {
      const galleryId = el.dataset.galleryId

      new Carousel(
        el,
        {
          infinite: false,
          Dots: false,
          Thumbs: {
            type: 'classic',
            Carousel: {
              slidesPerPage: 1,
              Navigation: true,
              center: false,
              fill: true,
              dragFree: true,
            },
          },
        },
        { Thumbs }
      );

      Fancybox.bind(`[data-fancybox="gallery-${galleryId}"]`, {
        idle: false,
        compact: false,
        dragToClose: true,

        animated: true,
        showClass: 'f-fadeSlowIn',
        hideClass: false,

        Carousel: {
          infinite: false,
        },

        Images: {
          zoom: true,
          Panzoom: {
            maxScale: 1.5,
          },
        },

        Toolbar: {
          absolute: true,
          display: {
            left: [],
            middle: [],
            right: ['close'],
          },
        },

        Thumbs: {
          type: 'classic',
          Carousel: {
            axis: 'x',

            slidesPerPage: 1,
            Navigation: true,
            center: true,
            fill: true,
            dragFree: true,

            breakpoints: {
              '(min-width: 640px)': {
                axis: 'x',
              },
            },
          },
        },
      });
    });
}
